module.exports = __webpack_public_path__ + "static/img/topBg.4f75511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topBg.png
// module id = km76
// module chunks = 1